// ************************************************************
// Note: this file is auto-generated, do not modify it directly
// ************************************************************
import { ShaderBinding, ConnectionPointType, ShaderBlock, createStrongRef } from "smart-filters";
/**
 * The shader program for the block.
 */
const BlockShaderProgram = {
    vertex: undefined,
    fragment: {
        uniform: `
            uniform sampler2D _input_; // main
            uniform float _intensity_;
            uniform bool _disabled_;
            uniform vec2 _aspect_;`,
        const: `            const float _videoPixelatePower_ = 6.0;
            const float _videoPixelateMin_ = 10.0;
            const float _videoPixelateMax_ = 1920.0;`,
        mainInputTexture: "_input_",
        mainFunctionName: "_pixelate_",
        functions: [
            {
                name: "_pixelate_",
                code: `
                    vec4 _pixelate_(vec2 vUV) { 
                        if (!_disabled_) {
                            float pixelateStrength = mix(_videoPixelateMin_, _videoPixelateMax_, pow(1. - _intensity_, _videoPixelatePower_));
                            vec2 _pixelate_ = vec2(pixelateStrength * _aspect_.x, pixelateStrength);
                            vec2 pixelSize = vec2(1. / _pixelate_);
                            vUV = pixelSize * (floor(_pixelate_ * vUV) + 0.5);
                        }
                        return texture2D(_input_, vUV);
                    }
                    `,
                params: "vec2 vUV",
            },
        ],
    },
};
/**
 * The uniform names for this shader, to be used in the shader binding so
 * that the names are always in sync.
 */
const Uniforms = {
    input: "input",
    intensity: "intensity",
    disabled: "disabled",
    aspect: "aspect",
};
/**
 * The shader binding for the PixelateBlock, used by the runtime
 */
class PixelateBlockShaderBinding extends ShaderBinding {
    /**
     * Creates a new shader binding instance for the block.
     * @param input - The input runtime value
     * @param intensity - The intensity runtime value
     * @param disabled - The disabled runtime value
     */
    constructor(input, intensity, disabled) {
        super();
        this._input = input;
        this._intensity = intensity;
        this._disabled = disabled;
    }
    /**
     * Binds all the required data to the shader when rendering.
     * @param effect - defines the effect to bind the data to
     * @param width - defines the width of the output
     * @param height - defines the height of the output
     */
    bind(effect, width, height) {
        effect.setTexture(this.getRemappedName(Uniforms.input), this._input.value);
        effect.setFloat(this.getRemappedName(Uniforms.intensity), this._intensity.value);
        effect.setBool(this.getRemappedName(Uniforms.disabled), this._disabled.value);
        effect.setFloat2(this.getRemappedName(Uniforms.aspect), width / height, height / width);
    }
}
/**
 * The implementation of the PixelateBlock
 */
export class PixelateBlock extends ShaderBlock {
    /**
     * Instantiates a new PixelateBlock.
     * @param smartFilter - The smart filter this block belongs to
     * @param name - The friendly name of the block
     */
    constructor(smartFilter, name) {
        super(smartFilter, name, false);
        /**
         * The input connection point.
         */
        this.input = this._registerInput(Uniforms.input, ConnectionPointType.Texture);
        /**
        /**
         * The intensity connection point.
         */
        this.intensity = this._registerOptionalInput("intensity", ConnectionPointType.Float, createStrongRef(0.3));
        /**
        /**
         * The disabled connection point.
         */
        this.disabled = this._registerOptionalInput("disabled", ConnectionPointType.Boolean, createStrongRef(false));
    }
    /**
     * Get the class instance that binds all the required data to the shader (effect) when rendering.
     * @returns The class instance that binds the data to the effect
     */
    getShaderBinding() {
        const input = this._confirmRuntimeDataSupplied(this.input);
        const intensity = this._confirmRuntimeDataSupplied(this.intensity);
        const disabled = this._confirmRuntimeDataSupplied(this.disabled);
        return new PixelateBlockShaderBinding(input, intensity, disabled);
    }
}
/**
 * The class name of the block.
 */
PixelateBlock.ClassName = "PixelateBlock";
/**
 * The namespace of the block.
 */
PixelateBlock.Namespace = "Babylon.Demo.Effects";
/**
 * The shader program (vertex and fragment code) to use to render the block
 */
PixelateBlock.ShaderCode = BlockShaderProgram;
//# sourceMappingURL=pixelateBlock.block.js.map